/**
 * Gateway payloads may send nested `stats.compute.*` or flat
 * `cpu_usage`, `memory_usage`, `disk_usage` percentages.
 */
export type GatewayCompute = {
  cpu?: { usage_percent?: number };
  memory?: {
    total_bytes?: number;
    used_bytes?: number;
    usage_percent?: number;
  };
  disk?: {
    total_bytes?: number;
    used_bytes?: number;
    usage_percent?: number;
  };
  temperature?: {
    cpu_celsius?: number;
    sensors?: { name: string; temperature: number; unit: string }[];
  };
  process?: {
    total_count?: number;
    running_count?: number;
    sleeping_count?: number;
    monitored_processes?: {
      name: string;
      pid: number;
      status: string;
      cpu_percent: number;
      memory_percent: number;
      memory_mb: number;
    }[];
  };
};

export function mergeGatewayCompute(stats: Record<string, unknown> | undefined): GatewayCompute {
  if (!stats) return {};
  const c = (stats.compute as GatewayCompute | undefined) || {};

  const cpuPct =
    c.cpu?.usage_percent ??
    (typeof stats.cpu_usage === 'number' ? stats.cpu_usage : undefined);
  const memPct =
    c.memory?.usage_percent ??
    (typeof stats.memory_usage === 'number' ? stats.memory_usage : undefined);
  const diskPct =
    c.disk?.usage_percent ??
    (typeof stats.disk_usage === 'number' ? stats.disk_usage : undefined);

  return {
    ...c,
    cpu: cpuPct != null ? { ...c.cpu, usage_percent: cpuPct } : c.cpu,
    memory: memPct != null ? { ...c.memory, usage_percent: memPct } : c.memory,
    disk: diskPct != null ? { ...c.disk, usage_percent: diskPct } : c.disk,
    temperature: c.temperature,
    process: c.process,
  };
}
